import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageService } from '@serengeti/serengeti-common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OauthService {

  loginEndPoint = environment.serviceMemberEndPoint + 'user/oauth/';
  userEndPoint = environment.serviceUserEndPoint + 'user/';

  getHeaders(authorization : any) : HttpHeaders{
    return new HttpHeaders({'Authorization' : authorization.token_type + ' ' + authorization.access_token});
  }

  constructor(private messageService : MessageService) { }

  newToken(authorization : any) : Observable<any> {
    let url = this.loginEndPoint + "token";
    return this.messageService.post(url, authorization);
  }

  access(code : any, state : any) : Observable<any> {
    let url = this.loginEndPoint;
    let params = new HttpParams()
      .set('code', code)
      .set('state', state);
    return this.messageService.query(url, params);
  }

  getUser(authorization : any) : Observable<any>{
    let url = this.loginEndPoint + "user";
    return this.messageService.post(url, authorization);
  }

  getOauth(userId) : Observable<any> {
    let url = this.loginEndPoint + "oauth";
    let params = new HttpParams()
      .set('userId', userId);
    return this.messageService.query(url, params);
  }

  createOauth(verification : any, refresh_token : any, userId : any, web : any, name : any, password : any) : Observable<any> {
    let url = this.loginEndPoint + "authorization";
    const authorization = {
      verification : verification,
      refreshToken : refresh_token,
      userId : userId,
      web : web
    }
    let params = new HttpParams()
    .set("email", userId)
    .set("name", name)
    .set("password", password);
    return this.messageService.post(url, authorization, params);
  }

  validateId(validateId) : Observable<any> {
    let url = this.userEndPoint + 'validateId';
    let params = new HttpParams()
      .set('userId', validateId);
    return this.messageService.query(url, params);
  }

  googleTokenRevoke(token) : Observable<any> {
    let url = this.loginEndPoint + "google"
    return this.messageService.post(url, token);
  }

  naverTokenRevoke(userId : any) : Observable<any> {
    let token = localStorage.getItem("naverAccessToken")
    let url = this.loginEndPoint + "naver";
    let params = new HttpParams()
      .set("userId", userId)
      .set("accessToken", token);
    return this.messageService.post(url, null, params);
  }

}
